import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { ExportViewProps, ExportViewRef } from "./models";
import SearchFilter, { Filters } from "../../../Common/SearchFilter/SearchFilter";
import { searchFilterToExportExcelFilter } from "../../../Common/SearchFilter/utils";
import useDidMountEffect from "../../../Common/UseDidMountEffect";
import { CodeHolder } from "../../../../model/CodeHolder";
import { ApiBackend } from "../../../../providers/apibackend";

type SearchFilterType = {
    codeHolderId?: string;
};

interface ISearchFilter {
    codeHolderId?: string;
}

const MecenatOrders = forwardRef<ExportViewRef, ExportViewProps>((props, ref) => {
    const [searchFilter, setSearchFilter] = useState(null as ISearchFilter);
const [coderHolders, setCodeHolders] = useState(null as CodeHolder[]);
    useImperativeHandle(ref, () => ({
        isValid: () => {
            return !!searchFilter?.codeHolderId;
        }
    }));

    useEffect(() => {
        let backend = new ApiBackend();
        backend.listCodes({codeHolderName:"Mecenat%"}).then((res) => {
            setCodeHolders(res);
        });
    },[]);

    useDidMountEffect(() => {
        props.onChange(searchFilterToExportExcelFilter<ISearchFilter>(searchFilter));
    }, [searchFilter]);

    const render = () => {
        return (
            <SearchFilter<SearchFilterType>
                id={"export-mecenatorders-filter"}
                filters={{
                    "codeHolderId": {
                        id: "filter-codeHolderId",
                        type: "GenericSelect",
                        label: "Kodhållare",
                        size: 12,
                        multiple: false,
                        itemDefinition: {
                            items: coderHolders == null ? [] : coderHolders.map(x=>{ return {name: x.name, value:x.id}}),
                            itemValueType: "string"
                        }
                    }
                }}
                persist={true}
                onInit={(filter: Filters<SearchFilterType>) => {
                    setSearchFilter(filter as unknown as ISearchFilter);
                }}
                onChange={(filter: Filters<SearchFilterType>) => {
                    setSearchFilter(filter as unknown as ISearchFilter);
                }}
            />
        );
    };

    return render();
});

export default MecenatOrders;
